/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	HoverPageCardsOptStatusQuery$data as HoverPageCardsOptStatusQuery,
	HoverPageCardsOptStatusQuery$variables as HoverPageCardsOptStatusQueryVariables,
} from '../__generated__/HoverPageCardsOptStatusQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { HoverPageCardsOptStatusQuery$data } from '../__generated__/HoverPageCardsOptStatusQuery.graphql.ts';
export type HoverPageCardsOptStatusQuery_userPreferences = NonNullable<HoverPageCardsOptStatusQuery$data['userPreferences']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum PageCardInPageTreeHoverPreference {
  NO_OPTION_SELECTED = "NO_OPTION_SELECTED",
  NO_SHOW_PAGECARD = "NO_SHOW_PAGECARD",
  SHOW_PAGECARD = "SHOW_PAGECARD",
}

